import React, { useState, useRef, useEffect, useContext } from 'react';
import './style.css';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { WindowSizeContext } from '/src/App';
import StandardButton from '/src/Components/StandardButton/StandardButton'; 


const HowThisWorks = () => {
    const { deviceType } = useContext(WindowSizeContext);

    const headlineText = "Our Priority Is You, Not a Paywall"
    const introText = "There’s truly no catch—no signup, no forms, no fees. We’re not here to scare you or sell you on specific upgrades. Our only aim is to give you clear, trustworthy insight so you can feel informed and confident about what’s right for your home, your family, and your future."
   
    const searchAddressImageFilename = "quoll-homepage-just-a-search_v2.webp"
    const searchAddressImageUrl = CreateCloudfrontUrl(searchAddressImageFilename);

    const personCelebratingImageFilename = "quoll-homepage-person-celebrating_v2.webp"
    const personCelebratingImageUrl = CreateCloudfrontUrl(personCelebratingImageFilename);

    const squigglyArrowImageFilename = "quoll-homepage-squiggly-arrow.svg"
    const squigglyArrowImageUrl = CreateCloudfrontUrl(squigglyArrowImageFilename);

    const buttonLinks = [
        {
            text: "Why is Quoll Free?",
            link: "/about/why-is-quoll-free"
        },
        {
            text: "FAQ",
            link: "/about/faq"
        }
    ]



    return (
        <div className={`home-page-section-container ${deviceType}`}>
            <div className="home-page-section-title">
                <h2>{headlineText}</h2>
            </div>
            <div className={`how-this-works-images-container ${deviceType}`}>
                <div className="how-this-works-images-item">
                    <div className="how-this-works-images-item-image-container">
                        <img src={searchAddressImageUrl} alt="Search Address" />
                    </div>
                    <span>You search an address</span>
                </div>
                <div className="how-this-works-images-item ">
                    <div className="how-this-works-images-item-image-container squiggly-arrow">
                        <img src={squigglyArrowImageUrl} alt="Squiggly Arrow" />
                    </div>
                </div>
                <div className="how-this-works-images-item">
                    <div className="how-this-works-images-item-image-container">
                        <img src={personCelebratingImageUrl} alt="Person Celebrating" />
                    </div>
                    <span>We give you everything</span>
                </div>
            </div>
            <p className="features-description text-align-center">{introText}</p>
            <div className={`meet-quoll-button-links ${deviceType}`}>
                {buttonLinks.map((button, index) => (
                    <StandardButton
                        id={`how-this-works-button-${index}`}
                        text={button.text}
                        link={button.link}
                    />
                ))}
            </div>
        </div>
    );
};

export default HowThisWorks;